import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from '../crud.service';
import { Help } from '../../models/help';
import { lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HelpService extends CrudService<Help> {
  protected basePath = 'help'; // Specific for HelpService
  public instanceType = 'help'; // Used in base service for constructing URLs

  constructor(http: HttpClient) {
    super(http);
  }

  override getItemsAsPromise() {
    return lastValueFrom(
      this.http.get<{ [key: string]: Help }>(`${this.getBaseUrl()}`)
    );
  }
}
